import React from 'react';
import OptimizeSchedulePanel from './OptimizeSchedulePanel';

/** RRM → Optimize → Iperf Schedule: the site's scheduled iperf tests. */
export default function IperfSchedulePanel(props) {
  return <OptimizeSchedulePanel kind="iperf" {...props} />;
}
